/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Regex_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter regex pattern and press Enter" |
*
* @param {Compliance_Template_Regex_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_regex_placeholder = /** @type {((inputs?: Compliance_Template_Regex_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Regex_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regex-Muster eingeben und Enter drücken")
	return /** @type {LocalizedString} */ ("Enter regex pattern and press Enter")
});